import React from 'react'
import cx from 'classnames'

import s from './Center.scss'


type CenterProps = {
  className?: string
  scrollable?: boolean
}


const Center: React.FunctionComponent<CenterProps> = ({ children, className, scrollable }) => {
  const rootClassName = cx(s.centringContainer, className, {
    [s.scrollable]: scrollable,
  })

  return (
    <div className={rootClassName}>
      <div className={s.centringContent}>
        {children}
      </div>
    </div>
  )
}


export default Center
